module.exports = new __parcel__URL__("MATLAB.717f7deb.jpg").toString();